/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-danger */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../../hooks/useAPIError';
import { useAuthStore } from '../../../store/AuthContext';
import { TarjetaService } from '../../../services';
import TarjetaTemporalSolicitarTarjeta from '../commons/TarjetaTemporalSolicitarTarjeta';
import ModalidadForm from '../commons/ModalidadForm';
import clubOro from '../../../assets/images/club-oro.png';
import SolicitarInformacionTPEC from '../commons/SolicitarInformacionTPEC';
import { BackMappings } from '../../../utils/BackMappings';
import { StorageHelper } from '../../../utils/StorageHelper';
import useSessionChecking from '../../../hooks/useSessionChecking';
import GestionesOro from '../commons/GestionesOro';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import { CryptoUtil } from '../../../utils/CryptoUtil';

const TitularOroEroski: FC = () => {
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.TARJETA);
  useSessionChecking(BackMappings.TARJETA, setGoOn, goOn);

  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const [showFormModalidad, setShowFormModalidad] = useState<boolean>(false);
  const [cuotaAltaSelected, setCuotaAltaSelected] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false as boolean);
  const [startSmsService, setStartSmsService] = useState(false);
  const [showActivaV2PModal, setShowActivaV2PModal] = useState(false);

  const { addError, addErrorBack } = useAPIError();
  const [load, setLoad] = useState<boolean>(true);
  const [cardNumberLong, setCardNumberLong] = useState<string>();
  const [firstCharge, setFirstCharge] = useState(true);

  const getCardNumber = () => {
    TarjetaService.getTarjeta()
      .then((response) => {
        if (response.data.error) {
          if (
            firstCharge &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setLoad(false);
          addErrorBack(response.data);
        } else {
          setCardNumberLong(
            CryptoUtil.decryptAes(response.data.pojo.cardNumberLong),
          );
        }
        setFirstCharge(false);
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
      setLoad(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getCardNumber();
    }
  });
  if (goOn) {
    return (
      <>
        <section className="header-tarjetas tarjetas">
          <div className="container">
            <div className="header-tarjetas__content">
              <h1 className="header-tarjetas__title">
                {t('tarjetas.tarjeta-club-oro.title')}
              </h1>
              <div className="bloque-etiquetas">
                <span className="etiqueta">
                  {t('tarjetas.tarjeta-club-oro.eroski-club')}
                </span>{' '}
                +{' '}
                <span className="etiqueta oro">
                  {t('tarjetas.tarjeta-club-oro.gold-card')}
                </span>
              </div>
              <p>
                {t('tarjetas.tarjeta-club-oro.partner-number')}{' '}
                <strong>{cardNumberLong}</strong>
              </p>
            </div>
          </div>
        </section>

        <section className="o-section--giant__top u-padding-bottom-hero section--background">
          <div className="container-inner">
            <div className="grupo-tarjetas">
              <div className="img-tarjeta">
                <img src={clubOro} alt="Tarjeta Eroski Club yTarjeta oro" />
              </div>
            </div>

            <div className="tarjeta__content">
              <h2 className="bloque-datos__title">
                <span className="divider__square brand-color" />
                <span className="u-margin-right">
                  {t('tarjetas.tarjeta-club-oro.eroski-club')}
                </span>
              </h2>

              <TarjetaTemporalSolicitarTarjeta />
              {(() => {
                if (
                  !dataUser.user.isImpagosOr3x12 &&
                  !StorageHelper.isEcommerceBot()
                ) {
                  return (
                    <>
                      <div className="divider small" />
                      <GestionesOro
                        setShowFormModalidad={setShowFormModalidad}
                        setCuotaAltaSelected={setCuotaAltaSelected}
                      />
                    </>
                  );
                }
                return false;
              })()}
            </div>
          </div>
        </section>
        {(() => {
          if (
            !dataUser.user.isGibraltar &&
            !dataUser.user.isEmpresa &&
            !StorageHelper.isEcommerceBot()
          ) {
            return (
              <section className="o-section--superhero tarjetas">
                <div className="container">
                  <h2 className="titulo-pagina u-text-brand u-text-center">
                    {t('tarjetas.tarjeta-club-mastercard.save-more')}
                  </h2>
                  <SolicitarInformacionTPEC />
                </div>
              </section>
            );
          }
          return false;
        })()}
        <ModalidadForm
          visible={showFormModalidad}
          setVisible={setShowFormModalidad}
          cuotaAltaSelected={cuotaAltaSelected}
        />
      </>
    );
  }
  return <></>;
};

export default TitularOroEroski;
